var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 366 261.3"
    },
    xmlSpace: "preserve",
    viewBox: "39 97.09 288 67.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300,117.7c7.8,0,14.7,3.3,15.9,9.1h-31.6C285.5,120.9,292.2,117.7,300,117.7z M140.8,152.8c17,0,28.3-6.4,28.3-17.8  c0-15.6-20.4-15.7-31.5-16.2c-3.7-0.2-18.4-0.2-18.4-5.9c0-5.7,11.1-7.7,18.5-7.7c11,0,19.8,3.4,24.7,7.2l5.1-7.2  c-6.3-4.3-15.7-8.1-30-8.1c-15.7-0.2-28.6,4.9-28.6,16.4c0,13.6,19,13.8,28.6,14.4c4.9,0.4,21.6-0.4,21.6,7.4  c0,6.6-8.8,9.3-18.4,9.3c-16.8,0-26.1-6-28.4-8l-5.2,8C116.6,151.2,126.7,152.8,140.8,152.8z M189.1,152.7c5,0,12.2-1.9,12.2-1.9  l-2.3-8.2c0,0-4,1.6-8.1,1.6c-3.9,0-5.2-1-5.2-4.3l-0.1-21.5h13.2v-8.1h-13.2V99.8h-9.7v10.6H169v8.1h6.9v21.6  C175.9,149.2,180.2,152.7,189.1,152.7L189.1,152.7L189.1,152.7z M226.7,164.3l30.1-53.9h-10.6l-16.7,30.7l-16-30.7H202l22.1,40.3  l-8,13.6H226.7z M259.7,151.2h9.8V98.1h-9.8V151.2z M284.2,134.8H327c-0.1-17.6-12.1-25.4-27-25.5c-15.9-0.1-26.5,8.8-26.5,21.7  s9.6,21.7,26.5,21.7c12.6-0.1,19.6-2.8,25.4-7.5l-5-6.7c-3.1,2.7-8.4,5.5-20.3,5.5C293.3,144.2,285.4,141.4,284.2,134.8z M39,151.2  h10.5v-53H39V151.2z M92.8,151.2h9.9l-0.1-24.4c0-11.6-6.8-17.6-21.6-17.6c-8.6,0.1-14.3,3.2-16.6,4.8v-3.6h-9.8v40.8h9.8v-27.6  c1-1,7-5.8,16.2-5.8c9.8,0,12.1,3,12.1,12.4L92.8,151.2L92.8,151.2z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInStyle);
export default __webpack_public_path__ + "static/media/in-style.0b813644006b7cd9722a4e49bbc116c5.svg";
export { ForwardRef as ReactComponent };